module.exports = __webpack_public_path__ + "static/img/Tech_03.3f4b499f.png";